<div
  [ngClass]="{
    'row-layout': !_noRow
  }"
>
  <div *ngIf="hasResolutions" style="flex: 1; max-width: 12rem">
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Auflösung</mat-label>
      <mat-select [formControl]="resolutionFC" [compareWith]="selectById">
        <mat-option *ngFor="let t of _resolutions" [value]="t">{{
          t.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div
    *ngIf="hasTypes"
    style="width: 9rem; margin-left: 1rem; margin-right: 1rem"
  >
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Format</mat-label>
      <mat-select [formControl]="typeFC" [compareWith]="selectById">
        <mat-option *ngFor="let t of _types" [value]="t">{{
          t.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
